// import axios from 'axios'

export default (routeTo, routeFrom, next) => {
  routeTo.params.layout = 'member'
  routeTo.params.histories = []

  next()
  // axios
  //   .post('/api/v2/booking_history')
  //   .then((res) => {
  //     routeTo.params.histories = res.data

  //     next()
  //   })
  //   .catch(() => {
  //     next({ name: '404', params: { resource: 'History' } })
  //   })
}
